//https://codepen.io/zadvorsky/pen/CoDes
import { Component, ViewChild, AfterViewInit, ElementRef, Output, EventEmitter } from '@angular/core';
import { MCFireWorkConfetti, Point } from './firework-confetti.definition';

@Component({
  selector: 'mc-firework',
  templateUrl: './firework-confetti.component.html',
  styleUrls: ['./confetti.scss'],
  standalone: false
})
export class FireWorkConfettiComponent implements AfterViewInit {
  @ViewChild('canvasConfetti') canvas: ElementRef;
  private ctx: CanvasRenderingContext2D;
  private particles: MCFireWorkConfetti[] = [];
  private animation_handler;
  private color_options: string[] = ['#4E5B73', '#00A3E0', '#6CC24A', '#F1C400', '#FF585D', '#FFFFFF', '#FFFFFF', '#FFFFFF'];
  @Output() animationCompleted: EventEmitter<boolean> = new EventEmitter<boolean>();
  public width: number = window.innerWidth;
  public height: number = window.innerHeight;

  constructor() {}
  ngOnInit() {}
  ngAfterViewInit() {
    this.canvas.nativeElement.width = window.innerWidth;
    this.canvas.nativeElement.height = window.innerHeight;
    this.ctx = this.canvas.nativeElement.getContext('2d');
    let self = this;
    this.createParticles();
    this.loop();
  }

  createParticles() {
    for (var i = 0; i < 2000; i++) {
      let color = this.color_options[Math.floor(Math.random() * (this.color_options.length - 1))];
      let left_corner = 2;
      let right_corner = -2;
      // var p0 = new Point(this.width * -2, this.height * -0.95); //<< left corner
      if (i >= 500) left_corner = -2;
      if (i >= 1000) right_corner = 2;
      if (i >= 1500) left_corner = 2;
      var p0 = new Point(this.width * left_corner, this.height * right_corner);
      var p1 = new Point(0.5 * this.width, 0.5 * this.height);
      var p2 = new Point(Math.random() * this.width, Math.random() * this.height);
      var p3 = new Point(Math.random() * this.width, this.height + 5);

      this.particles.push(new MCFireWorkConfetti(p0, p1, p2, p3, color, this.ctx));
    }
  }
  loop() {
    let self = this;
    (function animloop() {
      self.update();
      self.draw();

      if (self.checkParticlesComplete()) {
        self.particles.length = 0;

        self.animationCompleted.emit(true);
        clearTimeout(self.animation_handler);
        return;
      }
      self.animation_handler = window.requestAnimationFrame(animloop);

      return;
    })();
  }

  checkParticlesComplete() {
    for (var i = 0; i < this.particles.length; i++) {
      if (this.particles[i].completed === false) return false;
    }
    return true;
  }

  draw() {
    this.ctx.clearRect(0, 0, this.width, this.height);
    this.particles.forEach(function (p) {
      p.Draw();
    });
  }
  update() {
    this.particles.forEach(function (p) {
      p.Update();
    });
  }
}
